import { useEffect, useReducer, useRef } from 'react';
import { useStore } from '../contexts';

export const useStoreSelector = (selector, compare = Object.is) => {
  const stateMachine = useStore();

  const selectedRef = useRef(selector(stateMachine.getState()));
  const [, forceRender] = useReducer((x) => x + 1, 0);

  useEffect(() => {
    const handler = (newState) => {
      const newSelected = selector(newState);

      if (!compare(selectedRef.current, newSelected)) {
        selectedRef.current = newSelected;
        forceRender();
      }
    };

    const unsubscribe = stateMachine.subscribe(handler);

    return unsubscribe;
  }, [selector, compare, stateMachine]);

  return selectedRef.current;
};
